import React from 'react';
import PropTypes from 'prop-types';
import {
  KeyboardAvoidingView,
  View,
} from 'react-native';
import {
  Button, Input, Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { language } from '../../../localization';
import Breadcrumb from '../../../../vendor/react-native-breadcrumb';
import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
import {
  langValidation,
  appNameValidation,
  appDescValidation,
} from '../../../modules/validation/App';
import App from '../../../modules/data/App';
import LanguagePicker from '../../misc/LanguagePicker';

const validationSchema = yupObject().shape({
  lang: langValidation,
  appName: appNameValidation,
  appDesc: appDescValidation,
});

class PublisherAppFormApp extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (state.appName === '' && state.appDesc === '') {
      return {
        appName: (props.app && props.app.data && props.app.data.name) || '',
        appDesc: (props.app && props.app.data && props.app.data.desc) || '',
      };
    }
    return {};
  }

  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleNext = this.handleNext.bind(this);

    const { app } = this.props;

    this.state = {
      appName: (app && app.data && app.data.name) || '',
      appDesc: (app && app.data && app.data.desc) || '',
    };
  }

  handleCancel() {
    const { onCancel } = this.props;

    onCancel();
  }

  async handleNext(values, formikBag) {
    const {
      onSave,
      onPageSwitch,
      getAnalyticsService,
    } = this.props;
    const { appName, appDesc } = this.state;

    const val = values;
    val.appName = appName;
    val.appDesc = appDesc;

    formikBag.setSubmitting(true);
    const err = await onSave(val);
    if (err !== null) {
      getAnalyticsService().report.event('page1SaveError', 'create');
      formikBag.setStatus(err);
    } else {
      getAnalyticsService().report.event('page1SaveSuccess', 'create');
    }
    formikBag.setSubmitting(false);

    if (err === null) {
      onPageSwitch(2);
    }
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const { onPageSwitch, direction } = this.props;
    const { appName, appDesc } = this.state;

    return (
      <>
        <Breadcrumb
          entities={[
            translate('create_app_app'),
            translate('create_app_guide'),
            translate('create_app_endpoints'),
            translate('create_app_payment'),
            translate('create_app_links'),
            translate('create_app_review'),
          ]}
          isTouchable
          flowDepth={0}
          onCrumbPress={(index) => onPageSwitch(index + 1)}
          borderRadius={3}
          firstCrumbStyle={stylesPublisher.publisherAppEdit.firstCrumbStyle}
          crumbsContainerStyle={direction === 'column' ? stylesPublisher.publisherAppEdit.crumbsContainerStyle : stylesPublisher.publisherAppEdit.crumbsContainerStyleLandscape}
        />
        {/* Page 2: Guide Info */}
        <KeyboardAvoidingView
          style={[
            styles.view.form,
            {
              backgroundColor: 'white',
              width: '100%',
              padding: 0,
              margin: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
            },
          ]}
          behavior="padding"
        >
          <KeyboardAwareScrollView
            style={{
              flex: 1,
              width: '100%',
              maxWidth: 600,
              alignSelf: 'center',
              margin: 0,
            }}
            contentContainerStyle={{
              width: '100%',
              padding: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
              paddingBottom: 20,
            }}
            enableAutomaticScroll={false}
          >
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.lang && errors.lang ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              label={`${translate('app_lang')}:`}
              value={values.lang}
              onChange={(value) => setFieldValue('lang', value)}
              onBlur={() => setFieldTouched('lang')}
              errorMessage={touched.lang && errors.lang ? errors.lang : undefined}
              inputComponent={LanguagePicker}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.appName && errors.appName ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              label={`${translate('app_name')}:`}
              value={appName}
              placeholder={translate('app_name_placeholder')}
              // autoCapitalize="none"
              // autoFocus
              onChangeText={(value) => {
                setFieldValue('appName', value);
                this.setState({ appName: value });
              }}
              onBlur={() => setFieldTouched('appName')}
              errorMessage={touched.appName && errors.appName ? errors.appName : undefined}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={styles.form.inputLabel}
              inputStyle={[styles.form.inputInput, { paddingVertical: 10 }]}
              inputContainerStyle={touched.appDesc && errors.appDesc ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              label={`${translate('app_desc')}:`}
              value={appDesc}
              placeholder={translate('app_desc_placeholder')}
              // autoCapitalize="none"
              multiline
              numberOfLines={4}
              onChangeText={(value) => {
                setFieldValue('appDesc', value);
                this.setState({ appDesc: value });
              }}
              onBlur={() => setFieldTouched('appDesc')}
              errorMessage={touched.appDesc && errors.appDesc ? errors.appDesc : undefined}
            />
          </KeyboardAwareScrollView>
        </KeyboardAvoidingView>
        <View style={styles.form.containerButtons}>
          <Button
            title={translate('button_cancel')}
            containerStyle={styles.button.secondaryContainer}
            buttonStyle={styles.button.secondary}
            disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={this.handleCancel}
          />
          <Button
            title={translate('button_next')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
        </View>
      </>
    );
  };

  render() {
    const { app } = this.props;
    const { appName, appDesc } = this.state;

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={{
          lang: app.data.lang || language(),
          appName,
          appDesc,
        }}
        onSubmit={(values, formikBag) => this.handleNext(values, formikBag)}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAppFormApp.defaultProps = {
};

PublisherAppFormApp.propTypes = {
  app: PropTypes.instanceOf(App).isRequired,
  onCancel: PropTypes.func.isRequired,
  onPageSwitch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default PublisherAppFormApp;
